<template>
    <div>
        <div class="container mt-4 mb-4">
            <!-- <atras-component></atras-component> -->
            <boton-atras :nombre_ruta="'federal'"></boton-atras>
            <div class="row">
                <div class="col-md  mt-1 order-2 order-sm-2 order-md-1 order-lg-1">
                    <h6 class="subtitulo mb-2">Acuerdos</h6>
                    <div class="lineaNegra"></div>
                    <div class="mt-1 mb-2 lineaNegra2"></div>
                    <!-- AREA DE ARCHIVOS -->
                    <a :href="urlServe+'marco-juridico/Federal/informacion/Acuerdos/Proteccion-DP.pdf'" target="_blank">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-9">
                                    <h5> Acuerdo mediante el cual se aprueban las disposiciones administrativas de carácter general para la elaboración, presentación y valoración de evaluaciones de impacto en la protección de datos personales. </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div> 
                            </div> 
                        </div>
                    </a>
                    <a href="http://www.dof.gob.mx/nota_detalle.php?codigo=5327835&fecha=24/12/2013" target="_blank">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-9">
                                    <h5> Acuerdo por el que se da a conocer a los Gobiernos de las Entidades Federativas la Distribución y Calendarización para la Ministración durante el Ejercicio Fiscal 2017, de los Recursos Correspondientes a los Ramos Generales 28 Participaciones a Entidades Federativas y Municipios, y 33 Aportaciones Federales para Entidades Federativas y Municipios. </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div> 
                            </div> 
                        </div>
                    </a>
                    <a href="http://www.dof.gob.mx/nota_detalle.php?codigo=5427775&fecha=01/03/2016" target="_blank">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-9">
                                    <h5> Acuerdo por el que se da a conocer a los gobiernos de las entidades federativas la distribución y calendarización para la ministración durante el ejercicio fiscal 2016, de los recursos correspondientes al Fondo de Aportaciones Múltiples en sus componentes de Infraestructura Educativa Básica, Media Superior y Superior. </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div> 
                            </div> 
                        </div>
                    </a>
                    <a href="http://dof.gob.mx/nota_detalle.php?codigo=5427774&fecha=01/03/2016" target="_blank">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-9">
                                    <h5> Acuerdo por el que se da a conocer a los gobiernos de las entidades federativas la distribución y calendarización para la ministración durante el ejercicio fiscal 2016, de los recursos correspondientes al Fondo de Aportaciones para la Seguridad Pública de los Estados y del Distrito Federal. </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div> 
                            </div> 
                        </div>
                    </a>
                    <a href="http://dof.gob.mx/nota_detalle.php?codigo=5423796&fecha=28/01/2016" target="_blank">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-9">
                                    <h5> Aviso mediante el cual se da a conocer a los gobiernos de las entidades federativas la distribución y calendarización para la ministración durante el ejercicio fiscal de 2016, de los recursos correspondientes al Fondo de Aportaciones Múltiples, en sus componentes de Infraestructura Educativa Básica, Media Superior y Superior. </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div> 
                            </div> 
                        </div>
                    </a>
                    <a href="http://dof.gob.mx/nota_detalle.php?codigo=5420652&fecha=18/12/2015" target="_blank">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-9">
                                    <h5> Acuerdo por el que se da a conocer a los gobiernos de las entidades federativas la distribución y calendarización para la ministración durante el ejercicio fiscal 2016, de los recursos correspondientes a los Ramos Generales 28 Participaciones a Entidades Federativas y Municipios, y 33 Aportaciones Federales para Entidades Federativas y Municipios. </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div> 
                            </div> 
                        </div>
                    </a>
                    <a :href="urlServe+'marco-juridico/Federal/informacion/Acuerdos/Criterios.pdf'" target="_blank">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-9">
                                    <h5> Criterios para incluir las erogaciones Plurianuales para proyectos de inversión en infraestructura, en el proyecto de Presupuesto de Egresos de la Federación </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div> 
                            </div> 
                        </div>
                    </a>
                     <a :href="urlServe+'marco-juridico/Federal/informacion/Acuerdos/Disposiciones.pdf'" target="_blank">
                        <div class="mb-2">
                            <div class="title_document" style="display:flex; justify-content:space-between;">
                                <div class="col-9">
                                    <h5> Por el que se establecen las disposiciones generales del Sistema de Evaluación de Desempeño </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div> 
                            </div> 
                        </div>
                    </a>

                                   
                </div>
                
                <div class="col-md order-1 order-sm-1 order-md-2 order-lg-2 ">
                    <div class="row margenes img_fija">
                        <div class="sec_imagen"> 
                            <img src="@/assets/imagenes/acuerdo.jpg" alt="">  
                        </div>
                    </div>
                    
                    
                </div>
            </div>
            <div class="text-aviso my-5">
                <h5> <span class="resaltado-vino">AVISO:</span> Los instrumentos jurídicos que se mencionan a continuación, son solo de referencia, encontrándose para su consulta oficial en el portal de internet de la <u><a href="https://www.sgg.chiapas.gob.mx/" target="_blank" class="resaltado-vino">Secretaría General de Gobierno</a></u>, o en su caso en la versión impresa en el órgano de difusión oficial.</h5>
            </div>
        </div>
    </div>
</template>

<script>
import atrasComponent from './../../reload.vue'
import botonAtras from './../../button-atras'
export default {
    mounted(){
        window.scrollTo(0, 0);
    },
    components:{
        atrasComponent,
        botonAtras
    }
}
</script>

<style scoped>
    .title_document { 
        padding: .8rem 1rem;             
        width: 100%;
        height: auto;
        border: 1px solid#dfdfdf ;
        border-radius: 5px;
        border-left: 3px solid #621132;

        display: flex;
        justify-content: space-between;
        align-items: center !important;
    } 

    .title_document:hover{
        box-shadow: 3px 8px 17px -13px rgba(0,0,0,0.75) !important;
    }

    .descargar{
        font-size: 0.9rem;
        color: #6c757d !important;
    }

    .subtitulo {
        font-weight: 400;
        font-size: 1.8rem;
        margin-top: 1rem;
    }
    .subtitulo2{
        font-weight: 400;
        font-size: 1.2rem;
        margin-top: .5rem;
        margin-bottom: 1rem ;
    }
    .title_document h5{
        font-size: 0.8rem;
        font-weight: 400;
        /* line-height: 20px; */
        text-align: justify;
    }

    .sec_imagen{ 
        width:85% !important;
        background-color: #560F2C;
        /* margin-top: 3rem; */
    }

    a{
        text-decoration: none !important;
        color: #212529;
    }
    a:hover{ color:#212529 !important; }
    /* margenes de la card consulta */
    .margenes{
        display: flex;
        justify-content: flex-end;
    }
    .text-aviso h5 {      

        font-size: 1rem;
        font-weight: 400;
        /* line-height: 20px; */
    }
    .resaltado-vino{
        color: #560F2C;
        font-weight: 500;
    }
    /* imagen fija */
    .img_fija{
        position: sticky !important;
        top: 7% !important;
        z-index: 1000 !important;
    }

@media only screen and (max-device-width : 900px) {
    .container{
        padding-right: 1% !important;
        padding-left: 1% !important;
    }
    .title_document{
        padding: .5rem 1rem .5rem .1rem;
        line-height: 20px;
    }

    /* margenes de la card consulta */
    .margenes{ justify-content: space-around; }
    .card-width{ width: 95%; }

    .subtitulo2{ font-size: 1rem; }

    .sec_imagen{ margin-top: 0rem; }
}

</style>